<section class="mt-section mt-grid in10" v-if="isSet() && familyPackSku">
  <div :class="$style.marginTop" v-if="showSkuLabel(familyPackData[0])">
    <div class="row">
      <div class="col is5 is9-xs is9-s">
        <label :for="$vId(this, 'externalsku')" class="mt-label mt-label--capitalise">
          {{$t('pages.submissions.components.upload.externalsku.external_sku_number')}} {{}}
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col is5 is9-xs is9-s" v-if="isSkuAvailable">
        <TextField
          :name="`external sku ${tag}`"
          label="external sku"
          type="text"
          :id="$vId(this, 'externalsku')"
          v-model="familyPackData[0].externalSku"
          :maxlength="100" 
          :readonly="(this.getUserRoles(this.user) === 'foundrySupport')"
          :blur="updateSku"
        />
      </div>
    </div>
  </div>

    <div :class="$style.marginTop" v-if="(this.getUserRoles(this.user) !== 'foundrySupport')">
      <div class="row" >
        <div class="col">
          <label :for="$vId(this, 'externalsku')" class="mt-label mt-label--capitalise">
            {{$t('pages.submissions.components.upload.externalsku.external_sku_number')}}
          </label>
          <p v-tooltip="{content: $t('pages.submissions.components.upload.results.custom_part_num'), placement: 'right'}"
            :class="$style.quesCustom">?</p>
        </div>
      </div>
      <div class="row">
      <div class="col is5 is9-xs is9-s" v-if="isSkuAvailable">
        <TextField
          :name="`external sku ${tag}`"
          label="external sku"
          type="text"
          :id="$vId(this, 'externalsku')"
          v-model="familyPackData[0].externalSku"
          :maxlength="100" 
          :readonly="(this.getUserRoles(this.user) === 'foundrySupport')"
          :blur="updateSku"
        />
      </div>
      </div>
    </div>
    <div v-if="Object.hasOwn(errors,'external sku')">
      <p class="mt-error" v-for="error in errors">{{error}}</p>
      <p :class="$style.mB15"></p>
    </div>
</section>
<div :class="[$style.singlePExSku]" v-else-if="isSet() && singlePackSku">
  <div v-if="isSingleSkuAvailable[getExternalSkuIndex]" :class="[$style.name, $style.singlePExSkuWid]">
    <span class="mt-label mt-label--capitalise" v-if="!hasRole(['foundrySupport'])">
      {{$t('pages.submissions.components.upload.externalsku.external_sku_number')}}
    </span>
    <span class="mt-label mt-label--capitalise" v-if="showSkuLabel(singleStyleData[getExternalSkuIndex])">
      {{$t('pages.submissions.components.upload.externalsku.external_sku_number')}}
    </span>
    <TextField
      :name="`external sku ${elementId} ${tag}`"
      :label="`external sku`"
      type="text"
      :key="elementId"
      :id="$vId(this, `externalsku${elementId}`)"
      v-model="singleStyleData[getExternalSkuIndex].externalSku"
      :input-class="[$style.metaField, {'mt-input--error': Object.hasOwn(errors,`external sku ${elementId} ${tag}`)},'mt-serif mt-serif--size4']"
      :read-only="hasRole(['foundrySupport'])"
      :blur="updateSku"
      :mouse-over="mouseOverHandler"
      :mouse-out="mouseOutHandler"
      rules="script_tag_validate:1|max:100"
    />
  </div>
</div>
<div v-else-if="customPackSku" :class="[$style.name, $style.mTop5]">
  <span class="mt-label" v-if="!hasRole(['foundrySupport'])">
    {{$t('pages.submissions.components.upload.externalsku.external_sku_number')}}
  </span>
  <!-- <span class="mt-label" v-if="showSkuLabel(result)">
    {{$t('pages.submissions.components.upload.externalsku.external_sku_number')}}
  </span> -->
  <TextField
    v-if="!hasRole(['foundrySupport'])"
    :name="`external sku ${elementId} ${tag}`"
    :label="`external sku`"
    type="text"
    label="part number"
    :id="$vId(this, `externalsku${elementId}`)"
    v-model="result.externalSku"
    :input-class="[$style.metaField, {'mt-input--error': Object.hasOwn(errors,`external sku ${elementId} ${tag}`)}, 'mt-serif mt-serif--size4']"
    :blur="() => updateSubmissionOnExternalSkuBlur(elementId)"
    rules="script_tag_validate:1|max:100"
  />
  <TextField
    v-if="hasRole(['foundrySupport']) && result.externalSku"
    :name="`external sku ${elementId} ${tag}`"
    :label="`external sku`"
    type="text"
    :id="$vId(this, `externalsku${elementId}`)"
    v-model="result.externalSku"
    :input-class="[$style.metaField, {'mt-input--error': Object.hasOwn(errors, `external sku ${elementId} ${tag}`)}, 'mt-serif mt-serif--size4']"
    :read-only="hasRole(['foundrySupport'])"
    :blur="updateSku"
  />
</div>
